/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapmoms4 } from './pages'

type TIdToPageMap = Record<PageIdStylioCapmoms4, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPMOMS4: TIdToPageMap = {
  [PageIdStylioCapmoms4.AGE_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapmoms4.URGE_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePage'),
  },
  [PageIdStylioCapmoms4.HAIR_COLOR_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapmoms4.EYES_COLOR_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapmoms4.JEWELRY_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapmoms4.BODY_SHAPE_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapmoms4.STYLIO_TO_HELP_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapmoms4.TALL_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapmoms4.WEIGHT_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapmoms4.URGE_2_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapmoms4.FEEL_ABOUT_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapmoms4.PERCENTAGE_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/PercentageQuestion'
      ),
  },
  [PageIdStylioCapmoms4.SHOPPING_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapmoms4.STYLE_MOST_MATTERS_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapmoms4.FAVORITE_COLORS_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_11_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_12_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_13_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_14_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages//likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages//likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_15_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_16_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_17_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_18_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapmoms4.LIKE_OR_DISLIKE_19_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapmoms4.STYLES_FEEL_LIKE_YOU_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapmoms4.URGE_3_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapmoms4.TIME_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/TimeQuestion'),
  },
  [PageIdStylioCapmoms4.TYPICAL_DAY_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/TypicalDayQuestion'
      ).then((m) => ({
        default: m.TypicalDayQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/TypicalDayQuestion'
      ),
  },
  [PageIdStylioCapmoms4.BRAND_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/BrandQuestion'
      ).then((m) => ({
        default: m.BrandQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapmoms4.FIND_NEW_CLOTHES_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapmoms4.NOTHING_TO_WEAR_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapmoms4.OLD_CLOTHES_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/OldClothesQuestion'
      ),
  },
  [PageIdStylioCapmoms4.COMBINE_CLOTHES_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapmoms4.OPTIMIZE_BUDGET_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapmoms4.URGE_4_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapmoms4.PREPARE_FLOW_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/prepareFlow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapmoms4.EMAIL_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms4/pages/email/Email'),
  },
  [PageIdStylioCapmoms4.EMAIL_CONSENT_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/email/EmailConsent'),
  },
  [PageIdStylioCapmoms4.PRE_PAYWALL_OFFER_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/abtest/PrePaywallOffer/PrePaywallOffer'
      ).then((m) => ({
        default: m.PrePaywallOffer,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/abtest/PrePaywallOffer/PrePaywallOffer'
      ),
  },
  [PageIdStylioCapmoms4.SUBSCRIPTIONS_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioCapmoms4.CANCEL_OFFER_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapmoms4.SUB_UPSELL_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms4/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapmoms4.UPSELL_CAPMOMS4]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms4/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms4/pages/upsell/Upsell'),
  },
  [PageIdStylioCapmoms4.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapmoms4.DOWNLOAD_CAPMOMS4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms4/pages/download-app/DownloadDefault'
      ),
  },
}
